import React from "react";
import { ThemeProvider } from "styled-components";
import "./App.css";
import AppRoutes from "./router";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import { getCurrentTheme } from "./themes";
import Notifier from "./features/notifications";
import AppWrapper from "./App.style";
import { QueryClient, QueryClientProvider } from "react-query";
import EmailFactorModal from "../src/features/user/components/EmailFactorModal";
// import EnrollTotpModal from "../src/features/user/components/EnrollTotpModal";
// import store from "./redux/store";
// import { setEnrolledTotpModalVidible } from "./features/user/UserSlice";

const queryClient = new QueryClient();

const App = () => {
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  // const enrolledTotpModalVidible = useSelector(
  //   (state) => state.user.enrolledTotpModalVidible
  // );
  const theme = useSelector((state) => state.user.theme);

  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={currentAppLocale.direction}
      theme={{
        token: {
          colorPrimary: "#5850ec",
          colorPrimaryText: "#5850ec",
          colorLink: "#5850ec",
          colorTextDisabled: "rgba(0, 0, 0, 0.75)",
          colorText: "#000000",
          fontFamily: "Rubik",
        },
      }}
    >
      <IntlProvider
        onError={(err) => {
          if (err.code === "MISSING_TRANSLATION") {
            // console.warn("Missing translation", err.message);
            return;
          }
          throw err;
        }}
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={getCurrentTheme(theme)}>
            <Notifier />
            <AppWrapper>
              <AppRoutes />
            </AppWrapper>
            {/* <EnrollTotpModal
              visible={enrolledTotpModalVidible}
              hideModal={() =>
                store.dispatch(setEnrolledTotpModalVidible(false))
              }
              engagement={true}
            /> */}
            <EmailFactorModal />
          </ThemeProvider>
        </QueryClientProvider>
      </IntlProvider>
    </ConfigProvider>
  );
};

export default App;
